import Partnership from 'routes/Partnership'

export default Partnership
